export const ENV = {
  API_URL:
    window._env_?.REACT_APP_CALC_ENGINE_BASE_URL ??
    process.env.REACT_APP_CALC_ENGINE_BASE_URL,
  REACT_APP_LICENSE_KEY:
    window._env_?.REACT_APP_LICENSE_KEY ??
    process.env.REACT_APP_LICENSE_KEY,
  APPLICATION_AUTHENTICATION_URL:
    window._env_?.REACT_APP_APPLICATION_AUTHENTICATION_URL ??
    process.env.REACT_APP_APPLICATION_AUTHENTICATION_URL,
  APPLICATION_AUTHENTICATION_REFRESH_URL:
    window._env_?.REACT_APP_APPLICATION_AUTHENTICATION_REFRESH_URL ??
    process.env.REACT_APP_APPLICATION_AUTHENTICATION_REFRESH_URL,
  APPLICATION_LOGOUT_URL:
    window._env_?.REACT_APP_APPLICATION_LOGOUT_URL ??
    process.env.REACT_APP_APPLICATION_LOGOUT_URL,
  COUNT_OF_INSTRUCTION_ROWS:
    window._env_?.REACT_APP_COUNT_OF_INSTRUCTION_ROWS ??
    process.env.REACT_APP_COUNT_OF_INSTRUCTION_ROWS,
  ROW_SIZE: window._env_?.REACT_APP_ROW_SIZE ?? process.env.REACT_APP_ROW_SIZE,
  ENGAGEMENT_ID:
    window._env_?.REACT_APP_ENGAGEMENT_ID ??
    process.env.REACT_APP_ENGAGEMENT_ID,
  CLIENT_ID:
    window._env_?.REACT_APP_CLIENT_ID ?? process.env.REACT_APP_CLIENT_ID,
  AG_GRID_API_KEY:
    window._env_?.REACT_APP_AG_GRID_API_KEY ??
    process.env.REACT_APP_AG_GRID_API_KEY,
  AZURE_AD_CLIENT_ID:
    window._env_?.AZURE_AD_CLIENT_ID ?? process.env.REACT_APP_AZURE_AD_CLIENT_ID,
  AZURE_AD_TENANT_ID:
    window._env_?.AZURE_AD_TENANT_ID ?? process.env.REACT_APP_AZURE_AD_TENANT_ID,
};

